import React, { useState, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Table, TextField } from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import PropTypes from "prop-types";
import "./Sinistres.css";
import { filterClaimm } from "../../store/action/claim.js";

import Skeleton from "@mui/material/Skeleton";
import getDateFromString from "../../utils/getDateFromString.js";
import * as Actions from "../../store/action/claim.js";
import { getAllServiceType } from "../../store/action/claimManagement.js";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ChartDialog from "../Dashboard/ChartDialog";
import { translateClaimStatus } from "../../utils/translateStatus";
import { translateDamageType } from "../../utils/translateDamageType";
import Autocomplete from "@mui/material/Autocomplete";
import { fetchGoodsByLicensePlate, getAllCoverage, getPolicyDetails } from "../../store/action/policy";
import {
  getAllInspector, getInspectionMissionByAssignedExpert, getInspectionMissionByMissionType,
} from "../../store/action/inspectionMission";
import { ManagementTypes } from '../../utils/ManagementTypes';
import { CiSearch } from "react-icons/ci";
import { GrPowerReset } from "react-icons/gr";
import { hasAuthorities } from "../../utils/authoritiesUtils.js";
import AddClaimDialog from "./AddClaimDialog";
import ReportingDialog from "./ReportingDialog";
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
function EnhancedTableHead(props) {
  const classes = useStyles();
  const { order, orderBy, onRequestSort, managementTypeClaimsByManagementType, claimStatusClaimsByStatus } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const headRows = [
    {
      id: "claimNumber",
      align: "center",
      label: "N° Sinistre",
    },
    ...(managementTypeClaimsByManagementType !== undefined &&
      managementTypeClaimsByManagementType !== ""
      ? []
      : [{ id: "managementType", align: "left", label: "Mode Gestion" }]
    ),
    // ...(managementTypeClaimsByManagementType !== undefined && managementTypeClaimsByManagementType !== "" ||
    //     claimStatusClaimsByStatus !== undefined && claimStatusClaimsByStatus !== ""
    //         ? []
    //         : [{ id: "reportingAgency", align: "left", label: "Agence" }]
    // ),
    //
    // // {
    // //   id: "reportingAgency",
    // //   align: "left",
    // //   label: "Agence",
    // // },
    {
      id: "occurrenceDate",
      align: "left",
      label: "Date survenance",
    },
    // {
    //   id: "reportingDate",
    //   align: "left",
    //   label: "Date déclaration",
    // },
    {
      id: "createdAt",
      align: "left",
      label: "Date creation",
    },
    ...(claimStatusClaimsByStatus !== undefined &&
      claimStatusClaimsByStatus !== ""
      ? []
      : [{ id: "status", align: "left", label: "Statut" }]
    ),
  ];

  return (
    <tr className={classes.tableHeadRows}>
      {headRows.map((row) => (
        <TableCell
          key={row.id}
          align={row.align}
          sortDirection={orderBy === row.id ? order : false}
          style={{ border: 0 }}
        >
          <TableSortLabel
            active={true}
            direction={orderBy === row.id ? order : "desc"}
            onClick={createSortHandler(row.id)}
            style={{
              whiteSpace: "nowrap",
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: 12,
              lineHeight: "18px",
              color: "rgba(181, 181, 195, 1)",
            }}
          >
            {row.label}
          </TableSortLabel>
        </TableCell>
      ))}
      <TableCell align="left" style={{ border: 0 }}>
        {" "}
      </TableCell>
    </tr>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },

  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",

  },

  tableWrapper: {
    padding: "40px",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    paddingLeft: "5px",
    width: "310px"
  },
  dateContainer: {
    border: "none",
    outline: "none",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
    height: "30px",
  },
  tableHeadRows: {
    height: "48px",
    background: "rgba(243, 246, 249, 1)",
    borderRadius: "6px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: "13.8px",
    fontWeight: 600,
    lineHeight: "20.7px",
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "149px",
    height: "30px",
    borderRadius: 5,
    marginLeft: "10px",
    fontFamily: "Poppins",
    fontSize: "12px",
  },
  optionLabel: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  inputContainer: {
    border: '0.61px solid rgba(226, 217, 239, 1)',
    background: 'rgba(255, 255, 255, 1)',
    width: '310px',
    height: '30px',
    borderRadius: 5,

  },
  optionItem: {
    width: "100%",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    specialInput: {
      color: "rgba(24, 28, 50, 0.58)",
      fontFamily: "Poppins",
      fontSize: "13px",
      fontWeight: 500,
      textAlign: "right",
      backgroundColor: "rgba(243, 246, 249, 1)",
      border: "none",
      width: "209px",
      height: "28px",
    },
  },
  autocompleteTag: {
    fontFamily: 'Poppins, sans-serif',
    backgroundColor: 'rgba(240, 243, 199, 1)',
    color: 'rgba(60, 101, 86, 1)',
    border: 'none',
    fontSize: '0.75rem',
    padding: '2px 6px',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '2px',
    borderRadius: '16px',
    display: 'inline-block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltip: {
    fontSize: '0.75rem',
    maxWidth: '300px',
    whiteSpace: 'pre-wrap',
  },
  dropdownMenu: {
    zIndex: 1,
    backgroundColor: 'white',
    border: '0.61px solid rgba(226, 217, 239, 1)',
    borderRadius: 6,
    position: "absolute",
    top: "100%",
    left: 0,
    marginTop: "13px",
    padding: 0,
    listStyleType: "none",
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    whiteSpace: "nowrap",
    color: 'rgba(32, 18, 70, 1)',
    fontFamily: 'Poppins',
    fontSize: '10px',
    fontWeight: 400,
    textAlign: 'left',
    display: "block",
  },
}));

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number,
  managementTypeClaimsByManagementType: PropTypes.string,
  claimStatusClaimsByStatus: PropTypes.string,
};

export default function Sinistres({ setIdClaim, setIndexRoute, claimStatusClaimsByStatus, managementTypeClaimsByManagementType }) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [modeGestionLabel, setmodeGestionLabel] = useState([]);
  const [claimStatus, setClaimStatus] = useState([]);
  const [affectedCoverages, setAffectedCoverages] = useState([]);
  const [claimType, setClaimType] = useState([]);
  const [expertOptions, setExpertOptions] = useState([]);
  const [expert, setExpert] = useState(null);
  const [expertInputValue, setExpertInputValue] = useState("");
  const [missionType, setMissionType] = useState([]);
  const [inspectionMissionIds, setInspectionMissionIds] = useState([]);
  const [inspectionMissionDetails, setInspectionMissionDetails] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [backendFilters, setBackendFilters] = useState({});

  const [dateRanges, setDateRanges] = useState({
    reportDate: { from: null, to: null },
    invoiceDate: { from: null, to: null },
    quotationDate: { from: null, to: null },
    missionDate: { from: null, to: null },
  });
  const [coverageType, setCoverage] = useState([]);
  const [claimNumberfilter, setClaimNumberfilter] = useState("");
  const [filterClaimData, setFilterClaimData] = useState([]);
  const { claimData, loading } = useSelector((state) => state.claimReducer);

  //const [inputType, setInputType] = useState("text"); // (for date field)
  //const [dateRange, setDateRange] = useState({ fromDate: null, toDate: null });
  const [inputTypeMissionDateFrom, setInputTypeMissionDateFrom] = useState("text");
  const [inputTypeMissionDateTo, setInputTypeMissionDateTo] = useState("text");
  const [inputTypeReportDateFrom, setInputTypeReportDateFrom] = useState("text");
  const [inputTypeReportDateTo, setInputTypeReportDateTo] = useState("text");
  const [inputTypeInvoiceDateFrom, setInputTypeInvoiceDateFrom] = useState("text");
  const [inputTypeInvoiceDateTo, setInputTypeInvoiceDateTo] = useState("text");
  const [inputTypeQuotationDateFrom, setInputTypeQuotationDateFrom] = useState("text");
  const [inputTypeQuotationDateTo, setInputTypeQuotationDateTo] = useState("text");
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();

  const truncateLabel = (label) =>
    label.length > 24 ? `${label.substring(0, 25)}..` : label;

  // Expert dropdown: only show options whose label contains the typed text (no MUI internal filter)
  const filteredExpertOptions = useMemo(() => {
    const search = (expertInputValue || "").trim().toLowerCase();
    if (!search) return expertOptions;
    return expertOptions.filter((opt) =>
      (opt?.label || "").toLowerCase().includes(search)
    );
  }, [expertOptions, expertInputValue]);

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };
  const loadClaims = async (
    pageNumber = page,
    limitNumber = rowsPerPage,
    filters = backendFilters
  ) => {
    const response = await dispatch(
      filterClaimm(filters, pageNumber + 1, limitNumber)
    );

    console.log("FilterClaim RAW response:", response);

    if (response?.data && Array.isArray(response.data)) {
      setFilterClaimData(response.data);
      setTotalCount(response.total ?? 0);
    } else {
      setFilterClaimData([]);
      setTotalCount(0);
    }
  };



  const fetchInspectors = async () => {
    try {
      const inspectors = await dispatch(getAllInspector());
      //console.log("inspector", inspectors)
      setExpertOptions(inspectors.map((inspector) => ({
        label: `${inspector?.personDetails.lastName} ${inspector?.personDetails.name}`,
        value: inspector?.associatedParty,
      })));
    } catch (error) {
      console.error("Error fetching inspectors:", error.message);
    }
  };

  const fetchInspectionMissions = async () => {


    try {
      const missions = await getInspectionMissionByAssignedExpert(expert.value);
      console.log("Fetched inspection missions:", missions);

      if (missions && Array.isArray(missions)) {
        setInspectionMissionIds(missions.map((mission) => mission._id));
        setInspectionMissionDetails(missions);
      } else {
        console.error("Unexpected API response format:", missions);
        setInspectionMissionIds([]);
        setInspectionMissionDetails([]);
      }
    } catch (error) {
      console.error("Error fetching inspection missions:", error.message);
      setInspectionMissionIds([]);
      setInspectionMissionDetails([]);
    }
  };


  useEffect(() => {
    fetchInspectors();
  }, [dispatch]);

  useEffect(() => {
    gestionData();
    ferchAllCoverage();
    // initial claims load is done by the filters effect below — calling
    // loadClaims here too made the table fetch/flicker twice on mount
  }, []);



  function handleRequestSort(event, property) {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    loadClaims(newPage, rowsPerPage);
  };


  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    setRowsPerPage(newLimit);
    setPage(0);
    loadClaims(0, newLimit);
  };


  const handleDateChange = (e, key, type) => {
    const { value } = e.target;
    setDateRanges((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [type]: value,
      },
    }));
  };

  const handleViewClick = (id) => {
    //console.log("id", id)
    setIndexRoute("SinistresSection");
    setIdClaim(id);
    navigate(`/sinistre/${id}`);
  };

  const filterByDateRange = (date, from, to) => {
    const dateObj = new Date(date);
    const fromDate = from ? new Date(from) : null;
    const toDate = to ? new Date(to) : null;

    const isAfterFrom = fromDate ? dateObj >= fromDate : true;
    const isBeforeTo = toDate ? dateObj <= toDate : true;

    return isAfterFrom && isBeforeTo;
  };






  const gestionData = () => {
    return dispatch(getAllServiceType());
  };

  const statusOptions = [
    'AWAITING_INSPECTION',
    'VEHICLE_INSPECTED',
    'AWAITING_FINAL_REPORT',
    'CLOSED'
  ];



  const claimTypeOptions = [
    "Autres dommages",
    "Recours IDA",
    "Défense IDA",
    "Recours-défense IDA",
    "Recours Hors-IDA",
    "Défense Hors-IDA",
    "Recours-défense Hors-IDA",
    "Recours connexe",
    "Défense connexe",
    "Recours-défense connexe",
    "Recours Gestion étrangère",
    "Défense Gestion étrangère",
    "Recours-défense Gestion étrangère",
    "Défense Gestion des Biens",
    "Corporel avec Réclamation Directe",
    "Recours Corporel",
    "Défense Corporel",
    "Recours-défense Corporel",
  ]

  const missionTypeOptions = [
    { value: '1', label: 'Demande Première Expertise' },
    { value: '2', label: 'Demande Deuxième Expertisee' },
    { value: '3', label: 'Contre-Expertise' },
    { value: '4', label: 'Arbitrage' },
    { value: '6', label: 'Rapport de carrence' },
  ];


  const translatedStatusOptions = statusOptions.map(status => ({
    label: translateClaimStatus(status),
    value: status,
  }));

  async function ferchAllCoverage() {
    await dispatch(getAllCoverage())
      .then((response) => setCoverage(response))
      .catch((error) => console.error("Error fetching Coverage:", error));
  }
  const resetFilters = () => {
    setmodeGestionLabel([]);
    setClaimStatus([]);
    setAffectedCoverages([]);
    setClaimType([]);
    setExpert(null);
    setExpertInputValue("");
    setMissionType([]);
    setInspectionMissionIds([]);
    setInspectionMissionDetails([]);

    setClaimNumberfilter("");

    setInputTypeMissionDateFrom("text")
    setInputTypeMissionDateTo("text")
    setInputTypeReportDateFrom("text");
    setInputTypeReportDateTo("text");
    setInputTypeInvoiceDateFrom("text");
    setInputTypeInvoiceDateTo("text");
    setInputTypeQuotationDateFrom("text");
    setInputTypeQuotationDateTo("text");

    setSearchValue("")


    setDateRanges({
      reportDate: { from: null, to: null },
      invoiceDate: { from: null, to: null },
      quotationDate: { from: null, to: null },
      missionDate: { from: null, to: null },
    });
    setBackendFilters({});
    setPage(0);
    loadClaims(0, rowsPerPage, {});

  };

  useEffect(() => {
    const newPage = Math.floor(filterClaimData?.length / rowsPerPage);
    setPage(Math.min(newPage, page));
  }, [filterClaimData?.length, rowsPerPage]);






  useEffect(() => {
    const filtersPayload = {};

    const sanitizeSearchValue = (value) => {
      if (typeof value !== "string") return null;

      const cleaned = value
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9_\- ]/g, "")
        .trim();

      if (!cleaned || cleaned.length > 50) return null;

      return cleaned;
    };

    const safeValue = sanitizeSearchValue(searchValue);

    if (safeValue) {
      const isPolicyNumber = /^C[A-Z0-9_-]{1,49}$/.test(safeValue);
      const isLicencePlate =
        /^R[A-Z0-9-]{1,49}$/.test(safeValue) ||
        /^[0-9A-Z-]*T[0-9A-Z-]*$/.test(safeValue) ||
        safeValue.includes("-");
      const isClaimNumber = /^[A-Z0-9_]{1,50}$/.test(safeValue);

      if (isPolicyNumber) {
        filtersPayload.policyNumber = safeValue;
      } else if (isLicencePlate) {
        filtersPayload.licencePlate = safeValue;
      } else if (isClaimNumber) {
        filtersPayload.claimNumber = safeValue;
      }
    }


    if (modeGestionLabel.length > 0) {
      filtersPayload.managementType =
        modeGestionLabel.length === 1
          ? modeGestionLabel[0].label
          : modeGestionLabel.map(m => m.label);
    }


    if (claimStatus.length > 0) {
      filtersPayload.status =
        claimStatus.length === 1 ? claimStatus[0] : claimStatus;
    }

    // -------------------
    // Reporting Date
    // -------------------
    if (dateRanges.reportDate.from || dateRanges.reportDate.to) {
      filtersPayload.reportDate = [
        dateRanges.reportDate.from,
        dateRanges.reportDate.to,
      ];
    }

    // -------------------
    // Occurrence / Mission Date
    // -------------------
    if (dateRanges.missionDate.from || dateRanges.missionDate.to) {
      filtersPayload.occurrenceDate = [
        dateRanges.missionDate.from,
        dateRanges.missionDate.to,
      ];
    }

    // Filter by expert (inspector): claims where this expert is in involvedParties with role Inspector
    if (expert) {
      const selectedOption = expertOptions.find((o) => o.label === expert);
      if (selectedOption?.value) {
        filtersPayload.involvedParties = {
          partyUid: selectedOption.value,
          role: "Inspector",
        };
      }
    }

    setBackendFilters(filtersPayload);

    setPage(0);
    loadClaims(0, rowsPerPage, filtersPayload);

  }, [
    searchValue,
    modeGestionLabel,
    claimStatus,
    dateRanges,
    expert,
    // expertOptions intentionally omitted: it is only read when an expert is
    // selected, and re-running on its load caused an extra fetch + flicker
  ]);


  return (
    <div className={classes.root}>

      <Paper className={classes.paper} >
        <div style={{ marginBottom: "40px" }}>
          <div
            style={{
              fontSize: 17,
              fontFamily: "Poppins",
              fontWeight: 600,
              color: "rgba(32, 18, 70, 1)",
              marginLeft: "20px",
              paddingTop: "20px", // << Note: changed to paddingTop
            }}
          >
            Filtrer par
          </div>



          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: "20px 10px",
              padding: "20px",
              alignItems: "center",
              maxWidth: "100%",
            }}
          >
            {/* Row 1, Col 1: N° Sinistre / Police / Immat. */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%"
              }}
            >
              <span className={classes.titreLabel} style={{ width: "20%" }}>
                N° Sinistre / Police / Immat.
              </span>
              <input
                type="text"
                className={classes.inputContainer}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchValue(value);
                }}
                value={searchValue}
                list="claimNumbers"
              />
            </div>


            {/* Statut */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%"
            }}>
              <span
                className={classes.titreLabel}
                style={{ display: "flex", alignItems: "center" }}
              >
                Statut
              </span>
              <Autocomplete
                multiple
                id="claim-status"
                options={translatedStatusOptions}
                value={
                  claimStatus.length > 0
                    ? claimStatus.map((status) => ({
                      label: translateClaimStatus(status),
                      value: status,
                    }))
                    : []
                }
                size="small"
                onChange={(event, newValue) => {
                  setClaimStatus(newValue.map((item) => item.value));
                }}
                getOptionLabel={(option) => option.label || ""}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    className={`${props.className} ${classes.optionItem}`}
                  >
                    {option.label}
                  </li>
                )}
                renderTags={(tagValue, getTagProps) => {
                  const visibleTag = tagValue[0];
                  const hiddenTags = tagValue.slice(1);
                  return (
                    <>
                      {visibleTag && (
                        <span
                          {...getTagProps({ index: 0 })}
                          className={classes.autocompleteTag}
                        >
                          {truncateLabel(visibleTag.label)}
                        </span>
                      )}
                      {hiddenTags.length > 0 && (
                        <span
                          className={classes.autocompleteTag}
                          title={hiddenTags
                            .map((tag) => tag.label)
                            .join(", ")}
                        >
                          ... ({hiddenTags.length})
                        </span>
                      )}
                    </>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={classes.inputContainer}
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                    }}
                  />
                )}
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  "& .MuiOutlinedInput-root": {
                    p: 1,
                    height: "fit-content",
                    backgroundColor: "rgba(243, 246, 249, 1)",
                    fontSize: "0.75rem",
                    display: "flex",
                    fontFamily: "Poppins",
                    border: "none",
                    alignItems: "center",
                    justifyContent: "center",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                  "& .MuiAutocomplete-popupIndicator": {
                    display: "none",
                  },
                  "& .MuiAutocomplete-tag": {
                    bgcolor: "rgba(240, 243, 199, 1)",
                    color: "rgba(60, 101, 86, 1)",
                    fontSize: "0.75rem",
                    padding: "2px 6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2px",
                  },
                  "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                    color: "rgba(60, 101, 86, 1)",
                    "&:hover": {
                      color: "rgba(60, 101, 86, 1)",
                    },
                  },
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value
                }
              />

            </div>

            {/* Expert */}
            {hasAuthorities("VIEW_EXPERT_FILTER") && (
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%"
            }}>
              <span
                className={classes.titreLabel}
              //style={{marginRight: "10px"}}
              >
                Expert
              </span>
              <Autocomplete
                id="expert-selector"
                options={filteredExpertOptions}
                value={
                  expertOptions.find((option) => option.label === expert) ||
                  null
                }
                inputValue={expertInputValue}
                onInputChange={(event, newInputValue) =>
                  setExpertInputValue(newInputValue ?? "")
                }
                size="small"
                filterOptions={(options) => options}
                onChange={(event, newValue) => {
                  setExpert(newValue?.label ?? null);
                  setExpertInputValue(newValue ? newValue.label : "");
                }}
                getOptionLabel={(option) => option?.label || ""}
                renderOption={(props, option) => (
                  <li
                    {...props}
                    className={`${props.className} ${classes.optionItem}`}
                  >
                    {option?.label}
                  </li>
                )}
                renderTags={(tagValue, getTagProps) => {
                  const visibleTag = tagValue[0];
                  const hiddenTags = tagValue.slice(1);
                  return (
                    <>
                      {visibleTag && (
                        <span
                          {...getTagProps({ index: 0 })}
                          className={classes.autocompleteTag}
                        >
                          {truncateLabel(visibleTag.label)}
                        </span>
                      )}
                      {hiddenTags.length > 0 && (
                        <span
                          className={classes.autocompleteTag}
                          title={hiddenTags
                            .map((tag) => tag.label)
                            .join(", ")}
                        >
                          ... ({hiddenTags.length})
                        </span>
                      )}
                    </>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className={classes.inputContainer}
                    InputProps={{
                      ...params.InputProps,
                      disableUnderline: true,
                    }}
                  />
                )}
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  "& .MuiOutlinedInput-root": {
                    p: 1,
                    height: "fit-content",
                    backgroundColor: "rgba(243, 246, 249, 1)",
                    fontSize: "0.75rem",
                    display: "flex",
                    fontFamily: "Poppins",
                    border: "none",
                    alignItems: "center",
                    justifyContent: "center",
                    "& fieldset": {
                      border: "none",
                    },
                  },
                  "& .MuiAutocomplete-input": {
                    fontSize: "0.75rem",
                    color: "rgba(32, 18, 70, 1)",
                  },
                  "& .MuiAutocomplete-inputRoot": {
                    padding: "4px 6px",
                  },
                  "& .MuiAutocomplete-popupIndicator": {
                    display: "none",
                  },
                  "& .MuiAutocomplete-tag": {
                    bgcolor: "rgba(240, 243, 199, 1)",
                    color: "rgba(60, 101, 86, 1)",
                    fontSize: "0.75rem",
                    padding: "2px 6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "2px",
                  },
                  "& .MuiAutocomplete-tag .MuiChip-deleteIcon": {
                    color: "rgba(60, 101, 86, 1)",
                    "&:hover": {
                      color: "rgba(60, 101, 86, 1)",
                    },
                  },
                }}
                isOptionEqualToValue={(option, value) =>
                  option.value === value
                }
              />


            </div>
            )}
            <div style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              flexWrap: "nowrap",
              flexDirection: "row",
              alignItems: "center",
            }}>
              {/* <button
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "10.77px",
                      fontWeight: 600,
                      lineHeight: "16.16px",
                      color: "rgba(255, 255, 255, 1)",
                      background: "rgba(27, 197, 189, 1)",
                      width: "99.73px",
                      height: "30px",
                      borderRadius: "5.39px",
                      border: "none",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "4px",
                    }}
                    onClick={filterClaims}
                >
                  <CiSearch
                      style={{
                        height: "20px",
                        width: "20px",
                        color: "rgba(255, 255, 255, 1)",
                        fontWeight: 600,
                        lineHeight: "16.16px",
                      }}
                  />
                  Recherche
                </button> */}
              <button
                style={{
                  fontFamily: "Poppins",
                  fontSize: "10.77px",
                  fontWeight: 600,
                  lineHeight: "16.16px",
                  color: "rgba(255, 255, 255, 1)",
                  background: "rgb(186, 213, 58)",
                  width: "99.73px",
                  height: "30px",
                  borderRadius: "5.39px",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px",
                  marginLeft: "15px"
                }}
                onClick={resetFilters}
              >
                <GrPowerReset
                  style={{
                    height: "20px",
                    width: "20px",
                    color: "rgba(255, 255, 255, 1)",
                    fontWeight: 600,
                    lineHeight: "16.16px",
                  }}
                />
                Réinitialiser
              </button>
              {hasAuthorities('VIEW_ADD_CLAIM_BUTTON') && (
                <AddClaimDialog
                  coverageType={coverageType}
                  claimTypeOptions={claimTypeOptions}
                  expertOptions={expertOptions}
                  onCreated={() => loadClaims()}
                />
              )}
              {hasAuthorities('VIEW_MISSION_REPORTING') && <ReportingDialog />}
            </div>
          </div>
        </div>
      </Paper>

      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              managementTypeClaimsByManagementType={managementTypeClaimsByManagementType}
              claimStatusClaimsByStatus={claimStatusClaimsByStatus}
            />
            {loading ? (
              <TableBody>
                {[...Array(10)].map((row, index) => {
                  return (
                    <tr hover style={{ height: "48px" }}>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      {/* <TableCell
              align="left"
              className={classes.tableCellSmall}
            >
              <Skeleton animation="wave" />
            </TableCell> */}
                      <TableCell
                        align="right"
                        className={classes.tableCellSmall}
                      >
                        <button
                          style={{
                            width: "61px",
                            height: "34px",
                            borderRadius: "6px",
                            background: "rgba(240, 243, 199, 1)",
                            border: 0,
                            fontFamily: "Poppins",
                            fontSize: "12px",
                            fontWeight: 600,
                            lineHeight: "18px",
                            color: "rgba(60, 101, 86, 1)",
                            cursor: "pointer",
                          }}
                        >
                          Voir
                        </button>
                      </TableCell>
                    </tr>
                  );
                })}
              </TableBody>
            ) : (
              <>
                {" "}
                {filterClaimData != null && filterClaimData?.length > 0 ? (
                  <TableBody>
                    {stableSort(filterClaimData, getSorting(order, orderBy))

                      .map((row, index) => {
                        return (
                          <tr
                            hover
                            //tabIndex={-1}
                            key={row._id || index}
                            style={{ height: "50px", whiteSpace: "nowrap" }}
                          >
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              <div style={{ display: "flex" }}>
                                <div style={{ width: "75%" }}>
                                  {row.claimNumber || ""}
                                </div>
                                {/*<div*/}
                                {/*    style={{*/}
                                {/*      height: "26px",*/}
                                {/*      borderRadius: "51px",*/}
                                {/*      background: "rgba(240, 243, 199, 1)",*/}
                                {/*      textAlign: "center",*/}
                                {/*      padding: "5px",*/}
                                {/*      fontFamily: "Poppins",*/}
                                {/*      fontSize: "10px",*/}
                                {/*      fontWeight: 500,*/}
                                {/*      lineHeight: "16px",*/}
                                {/*      color: "rgba(60, 101, 86, 1)",*/}
                                {/*    }}*/}
                                {/*>*/}
                                {/*  {translateDamageType(row.additionalData.typeOfClaim) || "-"}*/}
                                {/*</div>*/}
                              </div>
                            </TableCell>
                            {!managementTypeClaimsByManagementType && (
                              <TableCell
                                align="left"
                                className={classes.tableCellSmall}
                              >
                                <div
                                  style={{
                                    height: "26px",
                                    borderRadius: "51px",
                                    background: "rgba(240, 243, 199, 1)",
                                    textAlign: "center",
                                    padding: "5px",
                                    fontFamily: "Poppins",
                                    fontSize: "10.17px",
                                    fontWeight: 500,
                                    lineHeight: "15.26px",
                                    color: "rgba(60, 101, 86, 1)",
                                  }}
                                >
                                  {row.managementType || ""}
                                </div>
                              </TableCell>
                            )}
                            {/*{!managementTypeClaimsByManagementType && !claimStatusClaimsByStatus && (*/}
                            {/*    <TableCell*/}
                            {/*        align="left"*/}
                            {/*        className={classes.tableCellSmall}*/}
                            {/*    >*/}
                            {/*      {row.reportingAgency?.code || ""}*/}
                            {/*    </TableCell>)}*/}
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {getDateFromString(
                                row.occurrenceDate?.toString()
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {/*  {getDateFromString(row.reportingDate?.toString())}*/}
                              {/*</TableCell>*/}
                              {/*<TableCell*/}
                              {/*    align="left"*/}
                              {/*    className={classes.tableCellSmall}*/}
                              {/*>*/}
                              {getDateFromString(row.createdAt?.toString())}
                            </TableCell>
                            {!claimStatusClaimsByStatus && (
                              <TableCell
                                align="left"
                                className={classes.tableCellSmall}
                              >
                                <div
                                  style={{
                                    height: "26px",
                                    borderRadius: "51px",
                                    background: "rgba(240, 243, 199, 1)",
                                    textAlign: "center",
                                    padding: "5px",
                                    fontFamily: "Poppins",
                                    fontSize: "10.17px",
                                    fontWeight: 500,
                                    lineHeight: "15.26px",
                                    color: "rgba(60, 101, 86, 1)",
                                  }}
                                >
                                  {translateClaimStatus(row.status) || ""}
                                </div>
                              </TableCell>
                            )}
                            <TableCell
                              align="right"
                              className={classes.tableCellSmall}
                            >
                              <button
                                style={{
                                  width: "61px",
                                  height: "34px",
                                  borderRadius: "6px",
                                  background: "rgba(240, 243, 199, 1)",
                                  border: 0,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  lineHeight: "18px",
                                  color: "rgba(60, 101, 86, 1)",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleViewClick(row._id)}
                              >
                                Voir
                              </button>
                            </TableCell>
                          </tr>
                        );
                      })}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableCell
                      align="center"
                      style={{ fontFamily: 'Poppins', fontWeight: 400, fontSize: 15, lineHeight: '22.5px', color: 'rgba(70, 78, 95, 1)', padding: '20px' }}
                      colspan="7"
                    >
                      {" "}
                      Aucun sinistre disponible
                    </TableCell>
                  </TableBody>
                )}{" "}
              </>
            )}
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "18px",
              color: "rgba(32, 18, 70, 1)",
            }}
            labelRowsPerPage="Lignes par page"
          />
        </div>
      </Paper>

      <ChartDialog />
    </div>
  );
}